import { isUndefined } from 'lodash';

import { ButtonVariant, StandardSpinner } from '@dreryk/react-components';

import { usePatientDependenciesContext } from '../../../dependencies';
import { useVisitStatusGlobalState } from '../../../shared/VisitStatusResolver/VisitStatusResolver.hooks';
import { patientMedicalInformationTranslationKeys } from '../../../translations';

type ShowVisitButtonProps = {
   readonly visitId: number | undefined;
   readonly patientId: number;
};

export const ShowVisitButton = (props: ShowVisitButtonProps): JSX.Element | null => {
   const { showVisitButton: ShowVisitButtonComponent } = usePatientDependenciesContext();
   const { getStatus } = useVisitStatusGlobalState();
   const status = getStatus(props.visitId);
   const disabled = status !== 'FINISHED_APPROVED';

   if (isUndefined(props.visitId)) {
      return null;
   }

   if (isUndefined(status)) {
      return <StandardSpinner />;
   }

   return (
      <ShowVisitButtonComponent
         visitId={props.visitId}
         patientId={props.patientId}
         disabled={disabled}
         label={patientMedicalInformationTranslationKeys.diagnosis.table.options.showVisit.label}
         backActionLabel={patientMedicalInformationTranslationKeys.diagnosis.table.options.showVisit.backActionLabel}
         variant={ButtonVariant.SECONDARY}
      />
   );
};
